import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { openBtiDataErrorPopup } from '../../store/bti_error_data_popup';
import { checkBtiDistrictHidden } from '../bti_commercial_district';
import { checkBtiDistrictRatingHidden } from '../bti_district_rating';
import { checkBtiHouseDataHidden } from '../bti_commercial_house_data';
import { BtiCommercialFooter, IBtiCommercialFooterDispachProps, IBtiCommercialFooterStoreProps } from './index';

function mapDispatchToProps(dispatch: Dispatch<IState>): IBtiCommercialFooterDispachProps {
  return {
    openBtiDataErrorPopup: () => {
      dispatch(openBtiDataErrorPopup());
    },
  };
}

function mapStateToProps(state: IState): IBtiCommercialFooterStoreProps {
  const ratingLocation =
    (state.offerData.bti && state.offerData.bti.houseData && state.offerData.bti.houseData.ratingLocation) || null;
  const districtData = (state.offerData.bti && state.offerData.bti.districtData) || null;
  const houseData = (state.offerData.bti && state.offerData.bti.houseData) || null;
  const isBtiDistrictHidden = checkBtiDistrictHidden(districtData);
  const isBtiDistrictRatingHidden = checkBtiDistrictRatingHidden(ratingLocation);
  const isBtiHouseDataHidden = checkBtiHouseDataHidden(houseData);

  return {
    isVisible: !isBtiDistrictHidden || !isBtiDistrictRatingHidden || !isBtiHouseDataHidden,
  };
}

export const BtiCommercialFooterContainer = connect(mapStateToProps, mapDispatchToProps)(BtiCommercialFooter);
